export const TARGETS = {
  CREATE_USER: 'createUser',
  UPDATE_USER: 'updateUser',
  DELETE_USER: 'deleteUser',
  SELECTED_USER: 'selectedUser',
  SELECTED_USERS: 'selectedUsers',
  SEND_WELCOME_EMAIL: 'sendWelcomeEmail'
};
